import { UseFormSetValue } from 'react-hook-form';

import type { StepThreeFormSchema } from '../validations/add-template.validation';
import type { TemplateFormSchema } from '../validations/edit-template.validation';

import { MappingEditorStore } from '../store/mapping-editor.store';

export const restoreMapFieldsSessionFromSnapshot = (
  snapshot: StepThreeFormSchema,
  setValue: UseFormSetValue<TemplateFormSchema>,
): void => {
  setValue('stepThree.fieldMapping', snapshot.fieldMapping ?? {}, { shouldValidate: true });
  setValue('stepThree.fieldMappingTypes', snapshot.fieldMappingTypes ?? {}, {
    shouldValidate: true,
  });
  setValue('stepThree.tabs', snapshot.tabs ?? [], { shouldValidate: true });
  setValue('stepThree.detectedVariables', snapshot.detectedVariables ?? [], {
    shouldValidate: true,
  });
  setValue('stepThree.mergeFieldIssues', snapshot.mergeFieldIssues ?? [], { shouldValidate: true });
  setValue('stepThree.fileParsed', snapshot.fileParsed ?? false, { shouldValidate: true });
  const { setVariableMappings } = MappingEditorStore.getState();
  setVariableMappings(snapshot.fieldMapping ?? {}, snapshot.fieldMappingTypes ?? {});
};
